import React , {Component } from 'react';
import AUX from '../../../hoc/Aux_';
import {fetchKategori, fetchType, fetchTotalUnsur} from '../../../api/kugi';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import _ from 'lodash';


class Counter extends Component{

  constructor(props) {
    super(props);
    this.state = {
      totalFC: null,
      totalFT:[]
    }
  }

  componentWillMount() {
    //let totalFT = [];
    fetchKategori()
      .then(response => {
        if (response != null) {
          this.setState({totalFC:response.data.length});
        }
      })
      .catch(error => {
      });

      fetchTotalUnsur()
        .then(response => {
          if (response != null) {
            this.setState({totalFT:response.data});
          }
        })
        .catch(error => {
        });

      if(this.props.islight === true)
      {
        this.props.UpdateLight();
      }
    }

    render(){
        return(
            <AUX>
             <section className="bg-custom" style = {{padding:10}}>
                <div className="container">
                    <div className="row justify-content-center" id="counter">
                        <div className="col-md-3 text-white text-center  ">
                            <div className="counter-icon">
                                <i className="mdi mdi-folder"></i>
                            </div>
                            <h3 className="counter-value" >{this.state.totalFC}</h3>
                            <h5 className="counter-name">Jumlah Kategori Unsur</h5>
                        </div>

                        <div className="col-md-3 text-white text-center  ">
                            <div className="counter-icon">
                                <i className="mdi mdi-file-multiple"></i>
                            </div>
                            <h3 className="counter-value" >{this.state.totalFT}</h3>
                            <h5 className="counter-name">Jumlah Unsur</h5>
                        </div>


                    </div>
                </div>
           </section>
           </AUX>
        );
    }
}

export default Counter;
